import { chartsAPI } from "../api/api";
import { InfractionConsolidated, InfractionRanking, InfractionRankingFilter, InfractionSummarized } from "../store/types/infraction";
import { JOURNEY_OVERVIEW_STATUS, JourneyOverview, JourneyOverviewFilter } from "../store/types/journeyControl";
import { removeEmptyProperties } from "../utils/functions/functions";
import { handleServiceError } from "./handleServiceError";

export interface CheckMacroBody {
  user: string;
  vehicle: string;
  journey_event: string;
  started_at: string | null;
}

const journeyControlService = {
  getJourneyOverview: async (
    {
      filters,
      limit,
      offset,
    }: {
      filters: JourneyOverviewFilter;
      limit: number;
      offset: number;
    },
    section?: string
  ) => {
    try {
      const data: JourneyOverview[] = [
        {
          _id: "teste",
          name: "Leandro Duarte",
          cpf: "12345678910",
          plate: "ABC1234",
          journey_time: 50000,
          extra_hours: 50000,
          status: JOURNEY_OVERVIEW_STATUS.OK_WITH_PROBLEMS,
          worked_hours: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.OK_WITH_PROBLEMS
          },
          meal: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.OK
          },
          waiting: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.NOK
          },
          free_time: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.OK_WITH_PROBLEMS
          },
          journey_end: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.NOK
          }
        },
        {
          _id: "teste",
          name: "Leandro Duarte",
          cpf: "12345678910",
          plate: "ABC1234",
          journey_time: 50000,
          extra_hours: 50000,
          status: JOURNEY_OVERVIEW_STATUS.NOK,
          worked_hours: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.OK_WITH_PROBLEMS
          },
          meal: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.OK
          },
          waiting: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.NOK
          },
          free_time: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.OK_WITH_PROBLEMS
          },
          journey_end: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.NOK
          }
        },
        {
          _id: "teste",
          name: "Leandro Duarte",
          cpf: "12345678910",
          plate: "ABC1234",
          journey_time: 50000,
          extra_hours: 50000,
          status: JOURNEY_OVERVIEW_STATUS.OK,
          worked_hours: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.OK_WITH_PROBLEMS
          },
          meal: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.OK
          },
          waiting: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.NOK
          },
          free_time: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.OK_WITH_PROBLEMS
          },
          journey_end: {
            events: 2,
            infractions: 3,
            time: 50000,
            status: JOURNEY_OVERVIEW_STATUS.NOK
          }
        },
      ];
      const totalItems = 3;

      /*
      
      const response = await chartsAPI.get(`/v1/infraction/ranking`, {
        params: { 
          ...removeEmptyProperties({
            ...filters
          }), 
          limit, 
          offset 
        },
        headers: { section }
      });
      const data: JourneyOverview[] = response.data.data;
      const totalItems = Number(response.headers["x-total-count"]);
      
      */

      return { data, totalItems };
    } catch (error) {
      handleServiceError(error);
    }
  },
  getAdhesionChartData: async (
    startDate: string,
    endDate: string,
    granularity: string,
    referenceMonth?: string,
    userId?: string,
    section?: string
  ) => {
    try {
      const response = await chartsAPI.get(`/v1/infraction/typeperperiod`, {
        params: { 
          ...(!referenceMonth && startDate) && { start_date: startDate },
          ...(!referenceMonth && endDate) && { end_date: endDate },
          ...(referenceMonth) && { reference_month: referenceMonth },
          ...(granularity) && { granularity },
          ...(userId) && { user_id: userId },
        },
        headers: { section }
      });
      return response.data.data;
    } catch (error) {
      handleServiceError(error);
    }
  },
};

export default journeyControlService;
